<template>
  <page-inner v-if="format === 'A4'">
    <fiche
      class="fiche-container"
      style="display: flex; flex-direction: column"
    >
      <div style="justify-self: flex-start" class="height-top">
        <haut-fiche :p="p" :pm="pm" />
        <titre-fiche :p="p" :pm="pm" />
        <div class="pushes-gutter"></div>
      </div>
      <div
        style="margin: auto; overflow: hidden; width: 100%;"
        :style="{ height: `${availableHeight}px` }"
      >
        <image-fiche :p="p" :pm="{ axe: 1, axe_image: pm.gen_image }" />
      </div>
      <div style="justify-self: flex-end" class="height-bottom">
        <div class="pushes-gutter"></div>
        <cartouche-fiche :p="p" :pm="pm" />
      </div>
    </fiche>
  </page-inner>
</template>

<script>
import CartoucheFiche from "../../../PrintComponents/Fiche/Projet/CartoucheFicheA4";
import Fiche from "../../../PrintComponents/Fiche/Fiche";
import HautFiche from "../../../PrintComponents/Fiche/Projet/HautFiche";
import ImageFiche from "../../../PrintComponents/Fiche/Projet/ImageFiche";
import PageInner from "../../../PrintComponents/Page/PageInner";
import TitreFiche from "../../../PrintComponents/Fiche/Projet/TitreFiche";

export default {
  name: "FichePortrait",
  components: {
    CartoucheFiche,
    Fiche,
    HautFiche,
    ImageFiche,
    PageInner,
    TitreFiche
  },
  data() {
    return {
      availableHeight: 0
    };
  },
  props: {
    format: {},
    index: {},
    p: {},
    pm: {}
  },
  methods: {
    async resetDimensions() {
      this.availableHeight = 0;
      await new Promise(r => this.$nextTick(r));
      const fullHeight = this.$el
        .querySelector(".fiche-container")
        .getBoundingClientRect().height;
      const topHeight = this.$el
        .querySelector(".height-top")
        .getBoundingClientRect().height;
      const bottomHeight = this.$el
        .querySelector(".height-bottom")
        .getBoundingClientRect().height;
      this.availableHeight = fullHeight - topHeight - bottomHeight;
      await new Promise(r => this.$nextTick(r));
    }
  },
  mounted() {
    this.resetDimensions();
  },
  watch: {
    pm: {
      handler() {
        this.resetDimensions();
      },
      deep: true
    },
    ratio() {
      this.resetDimensions();
    }
  }
};
</script>
